export default [
    {
        path:'/',
        name:'community',
        component: resolve => require(['../../view/community/community.vue'], resolve),
        meta:{
            navShow:true,
            keepAlive: true // 需要缓存
        },
    },
    {
        path:'/checkTheDetails',
        name:'checkTheDetails',
        component: resolve => require(['../../view/community/checkTheDetails.vue'], resolve), 
    },
    {
        path:'/content',
        name:'content',
        component: resolve => require(['../../view/community/content.vue'], resolve), 
    },
    {
        path:'/commsearch',
        name:'commsearch',
        component: resolve => require(['../../view/community/commsearch.vue'], resolve), 
    },
]


// WEBPACK FOOTER //
// ./src/router/community/index.js